import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import './styles/global.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

// React.StrictMode 제거: react-leaflet-cluster가 StrictMode의 이중 마운트(mount→unmount→mount)에서
// _gridUnclustered 미초기화로 인해 TypeError를 발생시키는 비호환 문제가 있음.
// 프로덕션 빌드에는 영향 없음.
ReactDOM.createRoot(root).render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </QueryClientProvider>,
);
